import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { delay, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators'
import { ContentPredicateStream } from '../content-predicate-streams'

@Component({
  selector: 'hs-content-condition-guard',
  styleUrls: ['content-condition-guard.component.scss'],
  templateUrl: 'content-condition-guard.component.html',
})
export class ContentConditionGuardComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() guardedContent: TemplateRef<any> | null = null
  @Input() contentGuardCardMessage?: string
  @Input() contentGuardCardHeader?: string
  @Input() conditionsMet$?: ContentPredicateStream

  private readonly destroyed$ = new Subject<void>()
  private readonly showContentSubject$ = new BehaviorSubject<boolean>(false)
  /** @internal */
  readonly showContent$ = this.showContentSubject$.pipe(
    takeUntil(this.destroyed$),
    /**
     * The delay is done to ensure the destruction of the the guarded content.
     * This simplifies component design. If we can be confident that the guarded content will be destroyed on
     * switch, then the content does not need to worry about changes of inputs that are a cause of whatever the
     * content met predicate cares about like loaded accounts.
     */
    distinctUntilChanged(),
    delay(50),
    tap(x => this.cd.detectChanges()),
  )

  constructor(private readonly cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.conditionsMet$
      ?.pipe(takeUntil(this.destroyed$))
      .subscribe(conditionsMet => this.showContentSubject$.next(conditionsMet))
  }

  ngOnDestroy() {
    this.destroyed$.next()
    this.destroyed$.complete()
  }
}
